import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_ORIGIN =
	"https://stunning.studio";

const DEFAULT_IMAGE =
	"/img/seo/default.jpg";


const getAbsoluteUrl =
	(value) => {
		try {
			return new URL(
				value ||
					"/",
				SITE_ORIGIN,
			).toString();
		} catch (
			error
		) {
			return SITE_ORIGIN;
		}
	};


export default function SEO({
	title,
	description,
	creator,
	type = "website",
	image = DEFAULT_IMAGE,
	canonical,
	url = "/",
	indexable = true,
	follow = true,
}) {
	const absoluteImage =
		getAbsoluteUrl(
			image,
		);

	const absoluteUrl =
		getAbsoluteUrl(
			url,
		);

	const absoluteCanonical =
		canonical
			? getAbsoluteUrl(
					canonical,
			  )
			: null;

	const robots =
		indexable
			? "index, follow"
			: follow
				? "noindex, follow"
				: "noindex, nofollow";

	return (
		<Helmet>
			<title>
				{title}
			</title>

			<meta
				name="description"
				content={description}
			/>

			<meta
				name="robots"
				content={robots}
			/>

			<meta
				property="og:type"
				content={
					type ||
					"website"
				}
			/>

			<meta
				property="og:site_name"
				content="Stunning Studio"
			/>

			<meta
				property="og:title"
				content={title}
			/>

			<meta
				property="og:description"
				content={description}
			/>

			<meta
				property="og:image"
				content={absoluteImage}
			/>

			<meta
				property="og:url"
				content={absoluteUrl}
			/>

			<meta
				name="twitter:card"
				content="summary_large_image"
			/>

			{creator ? (
				<meta
					name="twitter:creator"
					content={creator}
				/>
			) : null}

			<meta
				name="twitter:title"
				content={title}
			/>

			<meta
				name="twitter:description"
				content={description}
			/>

			<meta
				name="twitter:image"
				content={absoluteImage}
			/>

			{absoluteCanonical ? (
				<link
					rel="canonical"
					href={absoluteCanonical}
				/>
			) : null}
		</Helmet>
	);
}